import { Component, defineAsyncComponent } from "vue";
import { DSIconAppearance } from "@/src/design_system/primitives/icon/types";
import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import { iconComponentManager } from "@/src/design_system/primitives/icon/utils/iconComponentManager";
import { ICONS } from "@/src/design_system/primitives/icon/constants/icons";

class IconStore {
  private static instance?: IconStore;

  private iconMap = new Map<DSIconAppearance, Record<string, ReturnType<typeof defineAsyncComponent> | null>>();

  private constructor() {}

  static getInstance(): IconStore {
    if (!this.instance) {
      this.instance = new IconStore();
    }

    return this.instance;
  }

  public getIconComponent(iconName: DSIconName, appearance: DSIconAppearance): Component | null {
    if (!this.iconMap.has(appearance)) {
      this.iconMap.set(appearance, iconComponentManager(ICONS, appearance));
    }

    const component = this.iconMap.get(appearance)?.[iconName] ?? null;

    if (!component) {
      console.error(`missing svg file of icon ${iconName as string}: appearance: ${appearance}`);
    }

    return component;
  }
}

export default IconStore.getInstance();
